import { Component, ViewChild, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunctions, SnackType, imagePath, imgTypes } from '@global/GlobalFunctions';
import { LevelAsset, AssetsDataService, ILevelAsset } from '@services/assets-data.service';
import { IOrganisationsHierarchy, OrganisationDataService, OrganisationsHierarchy } from '@services/organisation-data.service';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { Subject, combineLatest, distinctUntilChanged, filter, finalize, takeUntil, tap } from 'rxjs';
import { ListViewComponent } from '@syncfusion/ej2-angular-lists';
import { EditHierarchyLocationComponent } from '../../../dialogs/edit-hierarchy-location/edit-hierarchy-location.component';
import { EditHierarchyAssetComponent } from '../../../dialogs/edit-level-asset/edit-level-asset.component';
import { AuthenticationService, WebAppUser } from '@services/authentication.service';
import { EditAssetDatapointsComponent, EditAssetSettingsDialogData } from 'src/app/dialogs/edit-asset-datapoints/edit-asset-datapoints.component';
import { json } from 'express';
import { CommentDialogComponent } from 'src/app/dialogs/comment-dialog/comment-dialog.component';
import { AssetSearchDialogComponent } from 'src/app/dialogs/asset-search-dialog/asset-search-dialog.component';
import { BreadcrumbItemModel } from '@syncfusion/ej2-navigations';
import { BreadcrumbComponent } from '@syncfusion/ej2-angular-navigations';
import { AccountFeatures, AccountsService, IAccount, IFeature } from '@services/accounts.service';

interface MyBreadcrumbItem extends BreadcrumbItemModel {
	// add your custom context here
	data?: { id: number; uid: string; type: string;[key: string]: any };
}

@Component({
	selector: 'app-hierarchy-dashboard',
	templateUrl: './hierarchy-dashboard.component.html',
	styleUrls: ['./hierarchy-dashboard.component.scss']
})
export class HierarchyDashboardComponent implements OnDestroy {

	/** Path to Assets Images */
	public imagePathAssets(): string {
		return imagePath(this.accountGUID, imgTypes.organisationassets).toLowerCase()
	}

	public imagePathOrganisations(): string {
		return imagePath(this.accountGUID, imgTypes.organisations).toLowerCase()
	}

	public imagePathSubLocations(): string {
		return imagePath(this.accountGUID, imgTypes.sublocations).toLowerCase()
	}

	/** child */
	@Input() child: OrganisationsHierarchy;

	/** Side Nav Bar */
	@ViewChild('listviewInstance') listviewInstance: ListViewComponent;

	@ViewChild('pageBreadcrumbs') pageBreadcrumbs: BreadcrumbComponent;

	public cssClass: string = 'e-list-template';
	/** Observable Subject Finalise */
	private finalise = new Subject<void>();
	/** Route Asset Parameter */
	public hierarchicalLocation?: OrganisationsHierarchy
	/** Asset Children */
	public locationChildren: OrganisationsHierarchy[]
	/** Assets List */
	public locationAssets: LevelAsset[] = [];
	/** set the Selected nodes to the TreeView */
	public locationParents: OrganisationsHierarchy[];

	public breadcrumbItems: MyBreadcrumbItem[] = []
	// 	 [
	//     { text: 'Home', iconCss: 'e-icons e-home', url: '/', data: { id: 1, type: 'root' } },
	//     { text: 'Customers', url: '/customers', data: { id: 42, type: 'section' } },
	//     { text: 'James Smith', url: '/customers/12345', data: { id: 12345, type: 'user' } }
	//   ];

	/** Selected Text */
	public selectedLocation: string = ""
	/** selectedAsset */
	public selectedAsset?: ILevelAsset;
	/** Data to Tree View */
	public hierarchicalData: OrganisationsHierarchy[]
	/** Fields */
	public fields: any
	/** Child Path */
	public childPath: string = ""
	/** Navigation area Is Colapsed */
	public isCollapsed = false;
	/** accountID */
	public accountGUID: string
	/** OrganisationID */
	public OrganisationUID: string

	/** thisUser */
	public thisUser: WebAppUser;

	/** flaggedAssets */
	public flaggedAssets: any[] = [];

	public selectedAccount: IAccount;
	public AccountFeatures = AccountFeatures;

	/** hideButtons */
	public hideButtons: boolean = false;

	/**
		 *  Default Constructor
		 * @param organisationDataService Organisation Data
		 * @param assetsDataService AssetsDataService
		 * @param router router
		 * @param route route
		 * @param siteSubscriptions site Subscriptions
		 * @param globalFunctions global Functions
		 * @param dialog dialog
		 * @param authenticationService authenticationService
		 * @param cd ChangeDetectorRef
		 */
	constructor(
		public organisationDataService: OrganisationDataService,
		public assetsDataService: AssetsDataService,
		private router: Router,
		private route: ActivatedRoute,
		private siteSubscriptions: siteSubscriptions,
		private globalFunctions: GlobalFunctions,
		public dialog: MatDialog,
		public authenticationService: AuthenticationService,
		private cd: ChangeDetectorRef
	) {

		combineLatest([
			this.authenticationService.currentUser$.pipe(distinctUntilChanged()),
			this.siteSubscriptions.selectedAccount$.pipe(distinctUntilChanged()),
			this.siteSubscriptions.selectedAccountGUID$.pipe(distinctUntilChanged()),
			this.siteSubscriptions.selectedOrganisationUID$.pipe(distinctUntilChanged()),
			this.route.paramMap.pipe(distinctUntilChanged())
		]).pipe(
			takeUntil(this.finalise),
			// Ensure that subscriptions are not null or undefined
			filter(([currentUser, selectedAccount, selectedAccountGUID, selectedOrganisationUID, paramMap]) =>
				!!currentUser && !!selectedAccount && !!selectedAccountGUID && !!selectedOrganisationUID && paramMap.has('sublocation'))
		).subscribe({
			next: ([currentUser, selectedAccount, selectedAccountGUID, selectedOrganisationUID, paramMap]) => {
				this.thisUser = currentUser
				this.accountGUID = selectedAccountGUID;
				this.selectedAccount = selectedAccount;
				this.OrganisationUID = selectedOrganisationUID;

				let urlAccountID = this.router.url.split('/')[1];

				if (this.accountGUID.toLowerCase() != urlAccountID.toLowerCase() && this.router.url.includes('location') && !this.router.url.includes('routing#')) {
					this.router.navigateByUrl(`routing#${this.router.url}`);
				}

				var paramSublocation = paramMap.get('sublocation') ?? "";
				this.subscribeHierarchicalData(paramSublocation)
				// this.getFavouriteAssets();
				this.getFlaggedAssets();
				// this.subscribeSelectedAsset()
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
			}
		});
	}

	/**
	 * Page On Destroy Event Handler
	 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}

	/**
	 * getHierarchicalData
	 * @param paramAsset
	 */
	public subscribeHierarchicalData(subLocation: string) {
		this.siteSubscriptions.hierarchicalData$.pipe(
			tap(() => {
				this.locationParents = [];
				this.locationChildren = [];
				this.breadcrumbItems = [];
			}),
			takeUntil(this.finalise), distinctUntilChanged(),
			filter((data) => !!data)
		).subscribe({
			next: (data: string) => {
				this.locationAssets = [];
				this.hierarchicalData = <IOrganisationsHierarchy[]>JSON.parse(data);
				if (subLocation && (this.hierarchicalData.length > 0)) {
					this.fields = { dataSource: this.hierarchicalData, value: 'Uid', text: 'Name', child: 'SubChild' };
					this.hierarchicalLocation = this.organisationDataService.findObjectByUID(subLocation, this.hierarchicalData)

					/*** Route Found */
					if (this.hierarchicalLocation) {
						try {
							this.siteSubscriptions.SetSelectedhierarchicalLocation(this.hierarchicalLocation);
							this.locationParents = this.organisationDataService.getParents(this.hierarchicalData[0], this.hierarchicalLocation.Uid);
							try {
								const newItems = this.buildBreadcrumbItems(this.hierarchicalLocation, this.locationParents)
								this.breadcrumbItems = [...newItems];  // spreads into a new array reference
								this.pageBreadcrumbs.activeItem = '';
							} catch { }
							// this.cd.detectChanges();

							if (this.hierarchicalLocation.SubChild) {
								this.locationChildren = this.organisationDataService.getChildren(this.hierarchicalLocation);
								if (this.locationChildren) {
									for (const child of this.locationChildren) {
										let subAssets = <LevelAsset[]>this.assetsDataService.findAssets(child);
										let subwatches = <LevelAsset[]>this.assetsDataService.findAssets(child, true);
										let subActions = <LevelAsset[]>this.assetsDataService.findAssets(child, false, true);
										child.TotalAssetCount = subAssets.length;
										child.TotalWatchCount = subwatches.length;
										child.TotalActionCount = subActions.length;
									}
								}
							}
							if (this.hierarchicalLocation.Assets) {
								this.locationAssets = this.hierarchicalLocation.Assets;
								this.subscribeSelectedAsset();
							}
						}
						catch (error) { console.error(error); }
						this.selectedLocation = this.hierarchicalLocation.Name
					}
					else {
						// console.log("Route Not Found");
						/** Need to Reload the current URL */
					}
				}
				else { this.locationParents = [] }
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: this.siteSubscriptions.hierarchicalData$", false)
			},
			//complete: () => {console.log("this.siteSubscriptions.hierarchicalData$.subscribe: Complete");}
		});
	}

	public buildBreadcrumbItems(hierarchicalLocation: OrganisationsHierarchy, locationParents: OrganisationsHierarchy[]) {

		let breadcrumbItems = [];

		for (const breadCrum of this.locationParents) {
			if (breadcrumbItems.length == 0) {
				breadcrumbItems.push(
					{ text: breadCrum.Name, iconCss: 'e-icons e-home', data: { id: breadCrum.Id, uid: breadCrum.Uid, type: 'root' } }
				)
			} else {
				//  iconCss: 'e-icons e-folder',
				breadcrumbItems.push(
					{ text: breadCrum.Name, data: { id: breadCrum.Id, uid: breadCrum.Uid, type: 'location' } }
				)
			}
		}

		if ((locationParents && locationParents.length > 0) && locationParents[0].Uid != this.hierarchicalLocation?.Uid) {
			breadcrumbItems.push(
				{
					text: hierarchicalLocation.Name,
					data: { id: hierarchicalLocation.Id, uid: hierarchicalLocation.Uid, type: 'location' }
				}
			)
		}

		return breadcrumbItems

	}
	/**
	 * subscribeSelectedAsset
	 */
	subscribeSelectedAsset() {
		// Track the selected Asset
		this.siteSubscriptions.selectedAsset$.pipe(
			tap(() => { this.selectedAsset = undefined }),
			takeUntil(this.finalise), distinctUntilChanged(),
			filter((asset) => !!asset)
		).subscribe({
			next: (asset_s: any) => {
				// let asset2: LevelAsset = JSON.parse(asset)
				// let result = this.locationAssets.find((x: ILevelAsset) => x.AssetID == asset2.AssetID)
				// if (result) {
				// 	this.selectedAsset = asset2;
				// 	this.showAsset(asset2);
				// }
				let asset: LevelAsset;
				if (typeof (asset_s) == 'string') {
					asset = JSON.parse(asset_s)
					this.selectedAsset = asset
				} else {
					this.selectedAsset = asset_s
				}
				if (this.selectedAsset) {
					this.showAsset(this.selectedAsset)
				}
			},
			error: (error) => { }
		});
	}

	/**
	 * Bind the Select event
	 * @param asset
	 */
	public assetSelect(asset: ILevelAsset) {
		try {
			let selAsset: any = asset.AssetID;
			this.siteSubscriptions.SetSelectedAsset(asset);
		} catch (error) { console.error(error); }
	}

	/**
	 * Navigate to Asset
	 * @param assetID
	 */
	private showAsset(asset: ILevelAsset) {
		try {
			// Create the new child route segment
			let currentUrl = this.router.url.split("/");
			let newChildSegment = currentUrl.slice(0, 6).join("/");
			// Navigate to the new URL with the changed child route
			this.router.navigate([`${newChildSegment}/asset/${asset.AssetID}`], { relativeTo: this.route.parent });
		} catch (error) { console.error(error); }
	}

	/**
	 * Bind the Select event
	 * @param locationUID
	 */
	public locationSelect(locationUID: any) {
		try {
			let sellocation: any = locationUID;
			this.navigate(sellocation);
			// this.numberRND = Math.random()
		} catch (error) { console.error(error); }
	}

	onItemClick(event: any) {
		const locationUID = event.item.data['uid'];
		// console.log('Clicked breadcrumb item:', event.item);
		// console.log('Text:', event.item.text);
		// console.log('URL:', event.item.url);

		try {
			let sellocation: any = locationUID;
			this.navigate(sellocation);
			// this.numberRND = Math.random()
		} catch (error) { console.error(error); }

	}

	/**
	 * Navigate to Sub Location
	 * @param locationUID
	 */
	private navigate(locationUID: string) {
		try {
			// Create the new child route segment
			let currentUrl = this.router.url.split("/");
			currentUrl[5] = locationUID;
			let newChildSegment = currentUrl.slice(0, 6).join("/");
			// Navigate to the new URL with the changed child route
			this.router.navigate([newChildSegment], { relativeTo: this.route.parent });
			this.siteSubscriptions.SetSelectedSubLocation(locationUID)
		} catch (error) { console.error(error); }
	}

	/**
	 * Add ne w Asset
	 * @param subLocation
	 */
	addAsset(subLocation: OrganisationsHierarchy) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = <ILevelAsset>{};

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyAssetComponent, {
			data: _edit,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			this.assetsDataService.postOrganisationAssets$(this.accountGUID, this.OrganisationUID, subLocation.Uid, _edit).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((response) => !!response),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (response) => {
					this.subscribeOrganisationStructure(this.accountGUID, this.OrganisationUID)
				}
			});
		});

	}

	/**
	 * Edit the Company details
	 * @param editAsset
	 */
	editAsset(editAsset: ILevelAsset): void {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = { ...editAsset };

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyAssetComponent, {
			data: _edit,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			this.assetsDataService.patchOrganisationAssets$(this.accountGUID, this.OrganisationUID, _edit).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((response) => !!response),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (response) => {
					Object.assign(editAsset, result);
					this.subscribeOrganisationStructure(this.accountGUID, this.OrganisationUID)
					this.globalFunctions.DisplaySnackBar({
						message: "Asset Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				}
			});
		});
	}

	/**
	 * Edit the Company details
	 * @param editAsset
	 */
	showAssetDatapoints(editAsset: ILevelAsset): void {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = { ...editAsset };

		let dialogData = <EditAssetSettingsDialogData>{
			assetItem: _edit,
			OrganisationUID: this.OrganisationUID,
			selectedAccountUID: this.accountGUID
		}

		// Display the dialog box
		const dialogRef = this.dialog.open(EditAssetDatapointsComponent, {
			data: dialogData,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			this.globalFunctions.DisplaySnackBar({
				message: "Asset Settings Updated",
				type: SnackType.Info,
				duration: 1000
			});
		});
	}

	/**
	 * Add new location
	 * @param subLocation
	 */
	addLocation(subLocation: OrganisationsHierarchy) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		// Create a 'Local'/shallow copy of the location Information
		var _edit = <IOrganisationsHierarchy>{};

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyLocationComponent, {
			data: _edit,
		});

		// Update the original Location with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			this.organisationDataService.postOrganisationLocation$(this.accountGUID, this.OrganisationUID, subLocation, _edit).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((response) => !!response),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (response) => {
					this.subscribeOrganisationStructure(this.accountGUID, this.OrganisationUID)
				},
				error: (error) => {
					if (error["status"] != 404) {
						this.globalFunctions.HandleError(error, "Error: this.organisationDataService.postOrganisationLocation.subscribe$", false)
					}
				},
			});
		});
	}

	/**
	 * Get the Organisation Structure
	 * @param AccountID AccountID
	 * @param OrganisationID OrganisationID
	 */
	subscribeOrganisationStructure(AccountID: string, OrganisationUID: string) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		try {
			/** Get the Organisation for the selection */
			this.organisationDataService.getOrganisationStructure$(AccountID, OrganisationUID).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((structure) => !!structure),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (structure: any) => {
					try {
						/** Update the Organisation */
						var OrganisationStructure = <IOrganisationsHierarchy[]>JSON.parse(structure);
						this.siteSubscriptions.SethierarchicalData(OrganisationStructure);
					} catch (error) { console.error(error); }
				},
				error: (error) => {
					if (error["status"] != 404) {
						this.globalFunctions.HandleError(error, "Error: OrganisationData.getOrganisationStructure$(OrganisationUID).subscribe$", false)
					}
				},
				//complete: () => { console.log("OrganisationData.getOrganisationStructure$(OrganisationUID).subscribe: Complete"); }
			});
		} catch (error) { console.error(error); }
	}

	/**
	 * Edit the Location details
	 * @param imageURL
	 */
	viewImage(imageURL: string): void {
		this.globalFunctions.viewImageFullSize(imageURL);
	}

	public favouriteAssets: LevelAsset[] = [];

	/**
	 * getFavouriteAssets
	 */
	getFavouriteAssets() {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.assetsDataService.getUserFavouriteAssets$(this.accountGUID, this.OrganisationUID).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((response) => !!response),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (result) => {
				if (result[0].Data) {
					this.favouriteAssets = JSON.parse(result[0].Data);
				}
			},
			error: (error) => { this.globalFunctions.HandleError(error, "Error: this.assetsDataService.getUserFavouriteAssets$", false); },
		});
	}

	/**
	 * checkIfAssetFavourite
	 */
	checkIfAssetFavourite(asset: LevelAsset): boolean {
		if (this.favouriteAssets.length > 0) {
			let temp = this.favouriteAssets.find((x: LevelAsset) => x.AssetID == asset.AssetID);
			if (temp) {
				return true;
			}
		}
		return false;
	}

	/**
	 * addFavourite
	 */
	addFavourite(asset: LevelAsset) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.assetsDataService.postUserFavouriteAssets$(this.accountGUID, this.OrganisationUID, asset.AssetID).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((response) => !!response),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (result) => {
				this.favouriteAssets.push(asset);
				this.globalFunctions.DisplaySnackBar(
					{
						message: "Favourite Added",
						duration: 1000
					}
				);
			},
			error: (error) => { this.globalFunctions.HandleError(error, "Error: this.assetsDataService.postUserFavouriteAssets$", false); },
		});
	}

	/**
	 * removeFavourite
	 * @param asset asset
	 */
	removeFavourite(asset: LevelAsset) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.assetsDataService.deleteUserFavouriteAssets$(this.accountGUID, this.OrganisationUID, asset.AssetID, this.thisUser.Sub).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((response) => !!response),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (result) => {
				this.favouriteAssets = this.favouriteAssets.filter((x: LevelAsset) => x.AssetID != asset.AssetID);
				this.globalFunctions.DisplaySnackBar(
					{
						message: "Favourite Removed",
						duration: 1000
					}
				);
			},
			error: (error) => { this.globalFunctions.HandleError(error, "Error: this.assetsDataService.deleteUserFavouriteAssets$", false); },
		});
	}

	/**
	 * getFlaggedAssets
	 */
	getFlaggedAssets() {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.assetsDataService.getFlaggedAssets$(this.accountGUID, this.OrganisationUID).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((response) => !!response),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (result) => {
				if (result[0].Data) {
					this.flaggedAssets = JSON.parse(result[0].Data);
				}
			},
			error: (error) => {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "Error: this.assetsDataService.getFlaggedAssets$", false);
				}
			},
		});
	}

	/**
	 * checkIfAssetFlagged
	 */
	checkIfAssetFlagged(asset: LevelAsset): boolean {
		if (this.flaggedAssets.length > 0) {
			let temp = this.flaggedAssets.find((x: any) => x.AssetID == asset.AssetID);
			if (temp) {
				return true;
			}
		}
		return false;
	}

	/**
	 * addFlagged
	 */
	addFlagged(asset: LevelAsset) {
		const dialogRef = this.dialog.open(CommentDialogComponent, {
			width: '500px',
			data: {
				"HeaderText": "Add Flagged Asset",
				"DialogText": "Explain why you want to flag " + asset.Name + " - " + asset.Description
			}
		});
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// Perform the delete action with the comment
			// console.log('The dialog was closed with comment:', result.comment);
			// Create a local Subject to control the subscription lifecycle
			if (result.comment) {
				const fetchDataSubject = new Subject<void>();

				this.assetsDataService.postFlaggedAsset$(this.accountGUID, this.OrganisationUID, asset.AssetID, result.comment).pipe(
					takeUntil(fetchDataSubject), distinctUntilChanged(),
					filter((response) => !!response),
					finalize(() => {
						// Ensure the subscription is terminated and the subject is completed
						fetchDataSubject.next();
						fetchDataSubject.complete();
					})
				).subscribe({
					next: (result) => {
						this.flaggedAssets.push(asset);
						this.globalFunctions.DisplaySnackBar(
							{
								message: "Flag Added",
								duration: 1000
							}
						);
					},
					error: (error) => { this.globalFunctions.HandleError(error, "Error: this.assetsDataService.postFlaggedAsset$", false); },
				});
			}
		});
	}

	/**
	 * removeFlaggedAsset
	 * @param asset asset
	 */
	removeFlaggedAsset(asset: LevelAsset) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.assetsDataService.deleteFlaggedAsset$(this.accountGUID, this.OrganisationUID, asset.AssetID).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((response) => !!response),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (result) => {
				this.flaggedAssets = this.flaggedAssets.filter((x: any) => x.AssetID != asset.AssetID);
				this.globalFunctions.DisplaySnackBar(
					{
						message: "Flag Removed",
						duration: 1000
					}
				);
			},
			error: (error) => { this.globalFunctions.HandleError(error, "Error: this.assetsDataService.deleteFlaggedAsset$", false); },
		});
	}

	/**
	 * searchForAsset
	 */
	searchForAsset() {
		let assetList: LevelAsset[] = this.flattenAssets(this.hierarchicalData);
		const dialogRef = this.dialog.open(AssetSearchDialogComponent, {
			data: {
				assetList: assetList,
				hierarchy: this.hierarchicalData,
				currentLocation: { ...this.hierarchicalLocation }
			}
		});
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			let asset = assetList.find((x: LevelAsset) => x.AssetID == result.asset);
			if (asset) {
				this.goToFunctionalLocation(asset);
			}
		});
	}

	/** Getting list of assets from an input hierarchy */
	flattenAssets(hierarchy: OrganisationsHierarchy[]): any[] {
		let result: any[] = [];

		// Check if hierarchy is a valid array before proceeding
		if (!Array.isArray(hierarchy)) {
			return result;
		}

		// Iterate over each item in the input hierarchy
		for (const item of hierarchy) {
			// Check if the item has a non-empty 'Asset' property
			if (item.Assets && item.Assets.length > 0) {
				result = result.concat(item.Assets);
			}

			// Recursively add all 'Asset' properties of the item's subchildren
			result = result.concat(this.flattenAssets(item.SubChild));
		}

		return result;
	}

	/**
	 * goToFunctionalLocation
	 * @param asset asset
	 */
	goToFunctionalLocation(asset: LevelAsset) {
		this.siteSubscriptions.SetSelectedAsset(asset);
		this.router.navigate([`/${this.accountGUID}/organisation/${this.OrganisationUID}/location/${asset.ParentUID}/asset/${asset.AssetID}`]);
	}

	/**
	 * toggleHideButtons
	 * @param hide hide 
	 */
	toggleHideButtons(hide: boolean) {
		this.hideButtons = hide;
	}

	/**
		 * checkFeature
		 * @param feature feature   
		 * @returns 
		 */
	checkFeature(feature: AccountFeatures): boolean {
		if (this.selectedAccount && this.selectedAccount.Features) {
			return AccountsService.checkFeature(feature, this.selectedAccount)
			// return this.selectedAccount.Features.some((x: any) => x.FeatureID == feature && x.Enabled);
		}
		return false;
	}

}
